import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChakraProvider, theme } from '@chakra-ui/react';
import { Route, Router, Switch } from 'wouter';
import Home from '../Home/Screen';
import './App.css';
function App() {
    return (_jsx(ChakraProvider, Object.assign({ theme: theme }, { children: _jsx("div", Object.assign({ className: 'App' }, { children: _jsx(Router, { children: _jsxs(Switch, { children: [_jsx(Route, { path: '/', component: Home }), _jsx(Route, { children: "404, Not Found!" })] }) }) })) })));
}
export default App;
